__turbopack_context__.v({
  "bulletpointContainer": "Footer-module__rnk_JG__bulletpointContainer",
  "bulletpointIcon": "Footer-module__rnk_JG__bulletpointIcon",
  "bulletpointItem": "Footer-module__rnk_JG__bulletpointItem",
  "bulletpointList": "Footer-module__rnk_JG__bulletpointList",
  "bulletpointTitle": "Footer-module__rnk_JG__bulletpointTitle",
  "container": "Footer-module__rnk_JG__container",
  "copyright": "Footer-module__rnk_JG__copyright",
  "error": "Footer-module__rnk_JG__error",
  "inputWrapper": "Footer-module__rnk_JG__inputWrapper",
  "item": "Footer-module__rnk_JG__item",
  "itemMobile": "Footer-module__rnk_JG__itemMobile",
  "itemTitle": "Footer-module__rnk_JG__itemTitle",
  "items": "Footer-module__rnk_JG__items",
  "itemsMobile": "Footer-module__rnk_JG__itemsMobile",
  "link": "Footer-module__rnk_JG__link",
  "linkMobile": "Footer-module__rnk_JG__linkMobile",
  "logo": "Footer-module__rnk_JG__logo",
  "logoContainer": "Footer-module__rnk_JG__logoContainer",
  "mainContainer": "Footer-module__rnk_JG__mainContainer",
  "newsLetterButton": "Footer-module__rnk_JG__newsLetterButton",
  "newsLetterConsentError": "Footer-module__rnk_JG__newsLetterConsentError",
  "newsLetterConsentRow": "Footer-module__rnk_JG__newsLetterConsentRow",
  "newsLetterContainer": "Footer-module__rnk_JG__newsLetterContainer",
  "newsLetterDescription": "Footer-module__rnk_JG__newsLetterDescription",
  "newsLetterInputContainer": "Footer-module__rnk_JG__newsLetterInputContainer",
  "newsLetterInputRow": "Footer-module__rnk_JG__newsLetterInputRow",
  "newsLetterSubtitle": "Footer-module__rnk_JG__newsLetterSubtitle",
  "newsLetterText": "Footer-module__rnk_JG__newsLetterText",
  "newsLetterTitle": "Footer-module__rnk_JG__newsLetterTitle",
  "partner": "Footer-module__rnk_JG__partner",
  "partnerLogo": "Footer-module__rnk_JG__partnerLogo",
  "partnerLogos": "Footer-module__rnk_JG__partnerLogos",
  "partnerTitle": "Footer-module__rnk_JG__partnerTitle",
  "partnersContainer": "Footer-module__rnk_JG__partnersContainer",
  "social": "Footer-module__rnk_JG__social",
  "socials": "Footer-module__rnk_JG__socials",
  "socialsContainer": "Footer-module__rnk_JG__socialsContainer",
});
